// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M10.7 3.15A1.5 1.5 0 0 1 13.3 3.15L21.93 18.1A1.5 1.5 0 0 1 20.63 20.35H3.37A1.5 1.5 0 0 1 2.07 18.1ZM12 15A1 1 0 1 0 12 17 1 1 0 0 0 12 15M12 8A1 1 0 0 0 11 9V13A1 1 0 0 0 13 13V9A1 1 0 0 0 12 8"/>';

/** Warning (status). */
const icon: IconData = {
  id: "warning",
  name: "Warning",
  category: "status",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9V13M12 16L12 16M3.36 19.35H20.63A.5.5 0 0 0 21.06 18.6L12.43 3.65A.5.5 0 0 0 11.56 3.65L2.93 18.6A.5.5 0 0 0 3.36 19.35"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M12.51 2.5L12.96 2.76 13.3 3.15 22.03 18.34 22.09 18.59V19.1L22.03 19.35 21.77 19.8 21.59 19.99 21.14 20.25 20.63 20.35 3.1 20.32 2.85 20.25 2.4 19.99 2.22 19.8 1.96 19.35 1.9 19.1V18.59L2.06 18.1 10.85 2.95 11.03 2.76 11.48 2.5 11.73 2.43H12.26Z"/></g><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9V13M12 16L12 16M3.36 19.35H20.63A.5.5 0 0 0 21.06 18.6L12.43 3.65A.5.5 0 0 0 11.56 3.65L2.93 18.6A.5.5 0 0 0 3.36 19.35"/>',
    },
  },
  animation: () => import("../animations/warning.js"),
};

export default icon;
